import React from "react";
import { Icon } from "@chakra-ui/react";

export const ArrowDownStrokeIcon = ({ ...props }) => {
  return (
    <Icon as="svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8L6 14L7.41 15.41Z" fill="currentColor" />
    </Icon>
  );
};
